import React, { useContext, useEffect, useState } from "react";
import errorIcon from "../../images/errorRedIcon.png";
import successIcon from "../../images/successGreenIcon.png";
import LoadingIcon from "../../images/Loading_icon.gif";
import { UrlContext } from "../../contexts/UrlContext";

export default function Note({ expert_id, note }) {
  const [expertNote, setExpertNote] = useState("");
  const [prevValue, setPrevValue] = useState("");
  const [returnSuccess, setReturnSuccess] = useState(false);
  const [returnError, setReturnError] = useState(false);
  const [setTimeoutid, setSetTimeoutid] = useState(null);
  const [loading, setLoading] = useState(false);
  const { API_URL } = useContext(UrlContext);

  useEffect(() => {
    if (note) {
      setExpertNote(note);
      setPrevValue(note);
    }
  }, [note]);

  const handleUpdateNote = (newValue) => {
    setReturnError(false);
    setLoading(true);
    const expertNote = newValue;
    const expertID = expert_id;
    const expertData = {
      expertNote,
      expertID,
    };
    const tokenObj = JSON.parse(localStorage.getItem("eph-token"));
    const token = tokenObj.token;

    fetch(`${API_URL}save-expert-note`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify(expertData),
    })
      .then((res) => res.json())
      .then((data) => {
        setLoading(false);
        if (data.status === "success") {
          setPrevValue(newValue);
          setReturnSuccess(true);
          clearTimeout(setTimeoutid);
          setSetTimeoutid(
            setTimeout(() => {
              setReturnSuccess(false);
            }, 1500)
          );
        } else {
          setReturnError(true);
        }
      })
      .catch((err) => {
        console.log(err);
        setReturnError(true);
      });
  };

  return (
    <div className="ml-[-6px]" style={{ paddingBottom: "16px", position: "relative" }}>
      {/* Top-right EPH badge */}
      <div
        className="absolute -right-[24px] -top-[60px]  w-8 h-8 bg-[#365561] text-white font-bold flex items-center justify-center"
        style={{
          borderTopRightRadius: '19px',
          borderBottomLeftRadius: '50px',
        }}
      >
        <p className="text-white text-[10px] ml-1 -mt-1">EPH</p>
      </div>
      <textarea
        className="expert-note-textarea"
        placeholder="You can save notes about this expert here . . ."
        title="Note about this expert"
        style={{border: "none", outline: "none"}}
        value={expertNote}
        onChange={(e) => {
          setExpertNote(e.target.value);
        }}
        onBlur={(e) => {
          if (e.target.value === prevValue) return;
          handleUpdateNote(e.target.value);
        }}
      />
      {loading && (
        <img
          className="return-msg-icon"
          style={{ top: "29px", right: "3px" }}
          src={LoadingIcon}
          alt="loading"
          title="Loading..."
        />
      )}
      {returnSuccess && (
        <img
          className="return-msg-icon"
          style={{ top: "29px", right: "3px" }}
          src={successIcon}
          alt="success"
          title="Success"
        />
      )}
      {returnError && (
        <img
          className="return-msg-icon"
          style={{ top: "29px", right: "3px" }}
          src={errorIcon}
          alt="error"
          title="Error! Please reload"
        />
      )}
    </div>
  );
}